import produce from "immer";

import { IStoreState } from "../initialStoreState";

import {
	CLEAR_ORG_ENV_CONFIG_STATE,
	FETCH_ORG_ENV_CONFIG_LIST_FAILED,
	FETCH_ORG_ENV_CONFIG_LIST_PROGRESS,
	FETCH_ORG_ENV_CONFIG_LIST_SUCCESS,
} from "./orgEnvConfigActions";
import { LoadState } from "../../constants/enums";
import { OrgEnvConfigActions } from "../orgEnvConfig";
import { initialOrgEnvConfigState } from "./orgEnvConfig.types";

export const orgEnvConfigReducer = (
	state: IStoreState["orgEnvConfig"] = initialOrgEnvConfigState,
	action: OrgEnvConfigActions
) => {
	switch (action.type) {
		case FETCH_ORG_ENV_CONFIG_LIST_PROGRESS: {
			const newState = produce(state, (draftState) => {
				draftState.list = [];
				draftState.loading = LoadState.NotLoaded;
			});

			return newState;
		}
		case FETCH_ORG_ENV_CONFIG_LIST_SUCCESS: {
			const { data, totalRecords } = action.payload;

			const newState = produce(state, (draftState) => {
				draftState.list = data;
				draftState.loading = LoadState.Loaded;
			});

			return newState;
		}

		case FETCH_ORG_ENV_CONFIG_LIST_FAILED: {
			const newState = produce(state, (draftState) => {
				draftState.list = [];
				draftState.loading = LoadState.Failed;
			});

			return newState;
		}

		case CLEAR_ORG_ENV_CONFIG_STATE: {
			return initialOrgEnvConfigState;
		}

		default: {
			return state;
		}
	}
};
